"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThreeStateCheckbox = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _react = _interopRequireDefault(require("react"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _threeStateCheckboxModule = _interopRequireDefault(require("./three-state-checkbox.module.scss"));
var mapCheckedState = function mapCheckedState(value) {
  switch (value) {
    case 'CHECKED':
      return 'true';
    case 'UNCHECKED':
      return 'false';
    case 'MIXED':
      return 'mixed';
  }
};
var ThreeStateCheckbox = function ThreeStateCheckbox(_ref) {
  var _classnames;
  var id = _ref.id,
    className = _ref.className,
    label = _ref.label,
    labelClassName = _ref.labelClassName,
    description = _ref.description,
    value = _ref.value,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    testId = _ref['data-testid'];
  var onClick = function onClick(e) {
    e.stopPropagation();
    if (disabled) {
      return;
    }
    switch (value) {
      case 'CHECKED':
        onChange('UNCHECKED');
        break;
      case 'UNCHECKED':
        onChange('CHECKED');
        break;
      case 'MIXED':
        onChange('UNCHECKED');
        break;
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(_threeStateCheckboxModule.default['three-state-checkbox'], className)
  }, /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": testId,
    role: "checkbox",
    id: id,
    "aria-checked": mapCheckedState(value),
    "aria-disabled": disabled,
    className: (0, _classnames3.default)(_threeStateCheckboxModule.default['three-state-checkbox__styled-element'], (_classnames = {}, (0, _defineProperty2.default)(_classnames, _threeStateCheckboxModule.default['three-state-checkbox__styled-element--disabled'], disabled), (0, _defineProperty2.default)(_classnames, _threeStateCheckboxModule.default['three-state-checkbox__styled-element--checked'], value === 'CHECKED'), (0, _defineProperty2.default)(_classnames, _threeStateCheckboxModule.default['three-state-checkbox__styled-element--mixed'], value === 'MIXED'), _classnames)),
    onClick: onClick
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _threeStateCheckboxModule.default['three-state-checkbox__label-container']
  }, label && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: (0, _classnames3.default)(_threeStateCheckboxModule.default['three-state-checkbox__label'], labelClassName, (0, _defineProperty2.default)({}, _threeStateCheckboxModule.default['three-state-checkbox__label--disabled'], disabled))
  }, label), description && /*#__PURE__*/_react.default.createElement("div", {
    className: _threeStateCheckboxModule.default['three-state-checkbox__description']
  }, description)));
};
exports.ThreeStateCheckbox = ThreeStateCheckbox;